import { Route } from '@angular/router';
import { PivotTableComponent } from './feature-pivot-table.component';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { scopeLoader } from '@backoffice-frontend/shared/util-transloco';

export const pivotTableRoutes: Route = {
  path: 'raw-data',
  component: PivotTableComponent,
  children: [],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: {
        scope: 'raw-data', //snake-casing is changed from transloco when using selectTranslate with scope
        alias: 'raw-data',
        loader: scopeLoader(
          (lang: string, root: string) => import(`./${root}/${lang}.json`),
        ),
      },
    },
  ],
};
